import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import PortalShell from "../../components/Portal/PortalShell";
import useShopProfile from "../../hooks/useShopProfile";
import useLogout from "../../hooks/useLogout";
import PageSpinner from "../../components/PageSpinner/PageSpinner";

// Layout of the login QR flow (login + logged-in pages): portal header + page.
// Pages read { shop, reviewType, shopLoading, shopNotFound } via useOutletContext
// and render their content inside PortalBody.
const MainLayout = () => {
    const user = useSelector((state) => state?.Auth?.user);
    const handleLogout = useLogout();
    const { shop, reviewType, globalDisplay, loading, notFound } = useShopProfile();

    return (
        <PortalShell
            shop={shop}
            globalDisplay={globalDisplay}
            // Only a logged-in customer has user info (cleared on logout)
            user={user?.email ? user : null}
            onLogout={handleLogout}
        >
            {/* Lazy pages load under the header instead of replacing the layout */}
            <Suspense fallback={<PageSpinner />}>
                <Outlet
                    context={{
                        shop,
                        reviewType,
                        shopLoading: loading,
                        shopNotFound: notFound,
                    }}
                />
            </Suspense>
        </PortalShell>
    );
};

export default MainLayout;
